"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensMixerMetadata = void 0;
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
function createBaseLensMixerMetadata() {
    return {
        mediaUnlockableId: "0",
        brandName: "",
        creatorUserId: new Uint8Array(),
        isRegulatedContent: false,
        callToAction: "",
        attachmentType: 0,
    };
}
exports.LensMixerMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mediaUnlockableId !== "0") {
            writer.uint32(8).int64(message.mediaUnlockableId);
        }
        if (message.brandName !== "") {
            writer.uint32(18).string(message.brandName);
        }
        if (message.creatorUserId.length !== 0) {
            writer.uint32(26).bytes(message.creatorUserId);
        }
        if (message.isRegulatedContent === true) {
            writer.uint32(32).bool(message.isRegulatedContent);
        }
        if (message.callToAction !== "") {
            writer.uint32(42).string(message.callToAction);
        }
        if (message.attachmentType !== 0) {
            writer.uint32(48).int32(message.attachmentType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensMixerMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mediaUnlockableId = longToString(reader.int64());
                    break;
                case 2:
                    message.brandName = reader.string();
                    break;
                case 3:
                    message.creatorUserId = reader.bytes();
                    break;
                case 4:
                    message.isRegulatedContent = reader.bool();
                    break;
                case 5:
                    message.callToAction = reader.string();
                    break;
                case 6:
                    message.attachmentType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensMixerMetadata();
        message.mediaUnlockableId = object.mediaUnlockableId ?? "0";
        message.brandName = object.brandName ?? "";
        message.creatorUserId = object.creatorUserId ?? new Uint8Array();
        message.isRegulatedContent = object.isRegulatedContent ?? false;
        message.callToAction = object.callToAction ?? "";
        message.attachmentType = object.attachmentType ?? 0;
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=lens_mixer_metadata.js.map